import { render, staticRenderFns } from "./LocationContextChange.vue?vue&type=template&id=0488af8c&scoped=true"
import script from "./LocationContextChange.vue?vue&type=script&lang=js"
export * from "./LocationContextChange.vue?vue&type=script&lang=js"
import style0 from "./LocationContextChange.vue?vue&type=style&index=0&id=0488af8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0488af8c",
  null
  
)

export default component.exports